export const getGeneralDeviceSettings = (state) => state.generalDeviceSettings;
